import { Autocomplete } from '@mui/material';
import styled from 'styled-components';

const FormGroup = styled.div`
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  @media (max-width: 768px) {
    margin-bottom: 12px;
  }
`;

const InfoText = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 4px;
  .info-text {
    color: #1c1c1ea3;
    font-size: 12px;
    font-weight: 400;
    letter-spacing: -0.4px;
  }
  .info-icon {
    color: #1e164ea3;
    font-size: 14px;
  }
  @media (max-width: 768px) {
    font-size: 11px;
    margin-top: 6px;
  }
`;

const StyledAutocomplete = styled(Autocomplete)`
  & .MuiOutlinedInput-root {
    height: 48px;
    border-radius: 12px;
    padding: 12px 16px;
    background: #ffffff;
    @media (max-width: 768px) {
      height: 40px;
      padding: 8px 12px;
    }
    // Border color
    & .MuiOutlinedInput-notchedOutline {
      border-color: #e0e0e0;
    }
    // Hover state
    &:hover .MuiOutlinedInput-notchedOutline {
      border-color: #bdbdbd;
    }
    // Focus state
    &.Mui-focused .MuiOutlinedInput-notchedOutline {
      border-color: #1976d2;
    }
    & input {
      padding: 0 !important;
      font-weight: 700;
      font-size: 16px;
      line-height: 24px;
      letter-spacing: -0.4px;
      vertical-align: middle;
    }
    & .MuiAutocomplete-endAdornment {
      right: 14px;
    }
  }
  & .MuiAutocomplete-input {
    font-weight: 700 !important;
    font-size: 16px !important;
    line-height: 24px !important;
    letter-spacing: -0.4px !important;
    vertical-align: middle !important;
  }

  & .MuiAutocomplete-input {
    font-weight: 700 !important;
    font-size: 16px !important;
    line-height: 24px !important;
    letter-spacing: -0.4px !important;
    vertical-align: middle !important;
  }
`;

export { StyledAutocomplete, FormGroup, InfoText };
